import { ThemeInterface } from 'redoc/typings/theme';

export const logoStyles = {
  logo: {
    gutter: '10px',
    maxHeight: '85px',
    maxWidth: '180px'
  }
} as ThemeInterface;
